import { render, staticRenderFns } from "./edutalk-paginate.vue?vue&type=template&id=47469cbf"
import script from "./edutalk-paginate.vue?vue&type=script&lang=js"
export * from "./edutalk-paginate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports